import _objectWithoutProperties from "C:\\Users\\conta\\PhpstormProjects\\efficience-vitale-reader\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties";
import _objectSpread from "C:\\Users\\conta\\PhpstormProjects\\efficience-vitale-reader\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import _classCallCheck from "C:\\Users\\conta\\PhpstormProjects\\efficience-vitale-reader\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\Users\\conta\\PhpstormProjects\\efficience-vitale-reader\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import { createError, errorTypes, softwareErrors } from '../errors';
var CustomWebsocket = /*#__PURE__*/function () {
  function CustomWebsocket(wsuri) {
    _classCallCheck(this, CustomWebsocket);
    this.socket = new WebSocket(wsuri);
    this.timeoutTimer = null;
    this.longRunningTimer = null;
    this.defaultTimeout = 30;
    this.defaultLongRunningTimeout = 60;
  }
  _createClass(CustomWebsocket, [{
    key: "close",
    value: function close() {
      this.socket.close();
    }
  }, {
    key: "closeAfterTimeout",
    value: function closeAfterTimeout(emit) {
      var error = createError(errorTypes.SoftwareErrors, softwareErrors.WEBSOCKET_TIMEOUT);
      emit({
        message: _objectSpread({}, error, {
          s_status: 'KO'
        })
      });
      this.socket.close(4000, 'the request timed out');
    }
  }, {
    key: "cancel",
    value: function cancel() {
      this.clearTimeouts();
      this.socket.close(4001, 'cancel the request');
    }
  }, {
    key: "clearTimeouts",
    value: function clearTimeouts() {
      clearTimeout(this.timeoutTimer);
      clearTimeout(this.longRunningTimer);
    }
  }, {
    key: "configEventHandlers",
    value: function configEventHandlers(emit, command, persistent) {
      var _this = this;
      this.socket.onerror = function (event) {
        var wsError = createError(errorTypes.SoftwareErrors, softwareErrors.WEBSOCKET_ERROR);
        var error = _objectSpread({}, wsError, event);
        emit({
          message: _objectSpread({}, error, {
            s_status: 'error'
          })
        });
        _this.clearTimeouts();
        _this.close();
      };
      this.socket.onopen = function () {
        var _command$timeout = command.timeout,
          timeout = _command$timeout === void 0 ? _this.defaultTimeout : _command$timeout,
          _command$longRunningT = command.longRunningTimeout,
          longRunningTimeout = _command$longRunningT === void 0 ? _this.defaultLongRunningTimeout : _command$longRunningT,
          multipleCalls = command.multipleCalls,
          commandParams = _objectWithoutProperties(command, ["timeout", "longRunningTimeout", "multipleCalls"]);
        var message = JSON.stringify(commandParams);
        _this.socket.send(message);
        if (!persistent) {
          _this.timeoutTimer = setTimeout(function () {
            _this.closeAfterTimeout(emit);
          }, timeout * 1000);
          _this.longRunningTimer = setTimeout(function () {
            emit({
              message: {
                s_status: 'too_long'
              }
            });
          }, longRunningTimeout * 1000);
        }
      };
      this.socket.onclose = function (event) {
        _this.clearTimeouts();
      };
      this.socket.onmessage = function (event) {
        var data = JSON.parse(event.data);
        emit({
          message: data
        });
        if (!persistent) {
          _this.close();
        }
      };
    }
  }]);
  return CustomWebsocket;
}();
export { CustomWebsocket as default };